import * as React from "react";
import { forwardRef } from "react";
const LogoPickPointSVG = (props, ref) => React.createElement("svg", { width: 16, height: 16, fill: "none", viewBox: "0 0 16 16", ref: ref, ...props },
    React.createElement("path", { fill: "#3E3F3C", d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0" }),
    React.createElement("path", { fill: "#fff", d: "M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0" }),
    React.createElement("path", { fill: "#D76443", d: "M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0" }));
const ForwardRef = forwardRef(LogoPickPointSVG);
export default ForwardRef;
//# sourceMappingURL=LogoPickPoint.js.map